import React from 'react'
import { Divider, Row, Col, Form, Input, Select, Button, Skeleton, message, Checkbox } from 'antd'
import * as deepObject from 'deep-object-diff'
import { FormComponent } from '../../../BaseComponent'
import { PartnerKeyTypeArray } from '../../../../interfaces/IIntegration'
import IShelter from '../../../../interfaces/IShelter'
import { SearchRequest } from '../../../../services/api/interfaces/ApiRequest'
import { PartnerAuthRequest } from '../../../../services/integration/interfaces/ApiRequest'

type IntegrationAuthProps = {
  authUuid?: string | null,
  error: any | null
  
  loading: boolean,
  contentLoading?: boolean
  history: any,

  shelters: IShelter[] | null

  loadShelters: (args: SearchRequest) => Promise<any>,
  
  authPartner: (args: PartnerAuthRequest) => Promise<any>,
  updateNetwork: (args: PartnerAuthRequest) => Promise<any>,
  closeModal: any,
  selectedItem:any
}

export default class IntegrationAuth extends FormComponent<IntegrationAuthProps> {

  static defaultProps = {
    contentLoading: true
  }

  state = {
    saving: false,
    loaded: false,

    partnerKey: this.props.selectedItem?.partner_key ? this.props.selectedItem?.partner_key : '',
    shelterUuid: this.props.selectedItem?.shelter?.uuid ? this.props.selectedItem?.shelter?.uuid : ''
  }

  componentDidMount() {
    const { shelters, loadShelters } = this.props;

    if (!shelters) {
      loadShelters({
        search: {
          deleted: false,
          organization_branches: {
            with: {
              deleted: false
            }
          }
        },
        options: {
          limit:9999
        }
      })
    }
  }

  componentDidUpdate(prevProps: IntegrationAuthProps, prevState: any) {
    const wasLoading = prevProps.loading && !this.props.loading
    let newState = Object.assign({}, this.state)
    
    if (!this.props.contentLoading && !newState.loaded) {
      newState.loaded = true
    }

    if (this.state.loaded) {
      if (this.state.saving && wasLoading) {
        newState.saving = false

        if (this.props.error) {
          message.error(`Could not make authentication with partner. Reason ${this.props.error}`)
        }
      }
    }

    const hasChanged = Object.keys(deepObject.diff(this.state, newState)).length > 0
    if (hasChanged) {
      this.setState(newState)
    }
  }

  async handleSave(values: any){
    this.setState({
      saving: true
    })
    let response = null;
    if(this.props.selectedItem?.uuid){
      const payload: any ={
          "network_uuid" : this.props.selectedItem?.uuid,
          "shelter_uuid": this.state.shelterUuid,
          "partner_key": this.state.partnerKey,
          "description": values.description,
          "active": values.active,
          "weight":  values.weight
      }
      response = await this.props.updateNetwork(payload)

    }else{
      const payload: any ={
          "shelter_uuid": this.state.shelterUuid,
          "partner_key": this.state.partnerKey,
          "description": values.description,
          "active": values.active,
          "weight":  values.weight
      }
      response = await this.props.authPartner(payload)
    }
   
    if(!(response as any)?.data?.error){
      this.props.closeModal();
    }
    
    this.setState({
      saving: false
    })
  }

  renderPartners = () => {
    return (
      <Select
        placeholder="Partner"
        allowClear={true}
        disabled={this.props.selectedItem}
        options={PartnerKeyTypeArray.map(partnerKey => {
          return {
            label: partnerKey,
            value: partnerKey
          }
        })}
        style={{
          width: "100%"
        }}
        defaultValue={this.props.selectedItem?.partner_key}
        onChange={(partnerKey: string) => this.setState({ partnerKey })}
      />
    )
  }

  renderShelters = () => {
    const { shelters } = this.props 
    return (
      <Select
        placeholder="Shelter"
        allowClear={true}
        showSearch={true}
        disabled={this.props.selectedItem}
        options={shelters?.map(shelter => {
          return {
            label: shelter.name,
            value: shelter.uuid
          }
        })}
        style={{
          width: "100%"
        }}
        filterOption={(input, option) => {
          if (!option?.label || typeof option.label !== 'string') return false

          return option.label.toLowerCase().indexOf(input.toLowerCase()) >= 0
        }}
        defaultValue={this.props.selectedItem?.shelter?.uuid}
        onChange={(shelterUuid: string) => this.setState({ shelterUuid })}
      />
    )
  }


  mountFields = () => {


    return (
      <Row gutter={24}>
        <Col span={12} key={`credential-field-description`}>
          <Form.Item
            label="Description"
            name={"description"}
          >
            <Input/>
          </Form.Item>
          <Form.Item
            label="Active"
            name={"active"}
            valuePropName="checked"
          >
            <Checkbox />
          </Form.Item>
        </Col>
        <Col span={12} key={`credential-field-description`}>
          <Form.Item
            label="Weight"
            name={"weight"}
          >
            <Input type="number" />
          </Form.Item>
        </Col>
      </Row>
    )
  }

  render() {
    const { loaded, saving } = this.state

    if (!loaded) {
      return <Skeleton />
    }

    return (
      <Form
        name="integration_auth"
        layout="vertical"
        onFinish={this.handleSave.bind(this)}
        initialValues={this.props.selectedItem}
        style={{
          marginTop: 30
        }}
      >
        <Row gutter={24}>
          <Col span={12}>
            {this.renderPartners()}
          </Col>

          <Col span={12}>
            {this.renderShelters()}
          </Col>

        </Row>

        <Divider />

        {
          this.mountFields()
        }

        <Form.Item style={{marginTop: 32}}>
          <Button type="primary" htmlType="submit" size="middle" loading={saving}>
            Save
          </Button>
        </Form.Item>
      </Form>
    )
  }
}
